import { ServiceRoutePath } from '$features/services/routes/protected'
import { Router } from '$utils/router'
import { Text } from '$components'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { SharedQueryParams } from 'src/enums/query'

type ServicePillProps = {
  service: {
    id: number
    values: {
      id: number
      is_latest: boolean
      name: string
    }
    colour: string
  }
}

export function ServicePill({ service }: ServicePillProps) {
  const serviceUrl = useMemo(() => {
    const baseUrl = Router.getRoute(ServiceRoutePath.ServicesView, { id: service.id })

    if (!service.values?.is_latest) {
      return `${baseUrl}?${SharedQueryParams.ValuesId}=${service.values?.id}`
    }

    return baseUrl
  }, [])

  return (
    <Link
      to={serviceUrl}
      className="flex items-center gap-2 border border-gray-100 rounded-xl px-2 py-1 hover:bg-gray-50/50"
    >
      <div
        className="size-2 rounded-full"
        style={{
          backgroundColor: service.colour,
        }}
      />
      <Text type="s">
        {service.values!.name}
      </Text>
    </Link>
  )
}
